import React, { useState, useEffect, Fragment } from 'react'
import {LoadingComponent} from 'recupero-comunes'
import {serviceGetSolicitudes} from '../../api/api-atender-informe-profesional';
import AtenderInformeRAT from './informe-rat'
import AtenderInformeMedico from './informe-medico'

const AtenderInformeProfesional = ({ showModal, setShowModal, idCaso, idOrgCaso, idSolicitud, idTrxOrigen, handleReload}) => {

    const TIPO_INFORME_MEDICO = 299001;
    const TIPO_INFORME_RAT = 299002;
    const [loading, setLoading] = useState(false);
    const [solicitud, setSolicitud] = useState(false);

    useEffect(() => {
        if (showModal) getSolicitudes();
    }, [showModal])

    const getSolicitudes = async () => {
        setLoading(true);   
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso })).toString('base64');
        const response = await serviceGetSolicitudes(query);

        if (response && response.length > 0) {
            let solicitud = (response?.filter((r) => (r.idSolicitud == idSolicitud)));
            setSolicitud(solicitud[0]);   
            console.log("solicitud: ", solicitud[0]);  
        }
        setLoading(false);
    }

return (
    <div>
        <Fragment>
            <LoadingComponent show={loading}/>
            { solicitud.codTipoInforme == TIPO_INFORME_RAT ? (                
            <>
                <AtenderInformeRAT 
                    showModal= {showModal} 
                    setShowModal={setShowModal} 
                    idCaso={idCaso}
                    idOrgCaso={idOrgCaso}
                    solicitud={solicitud} 
                    handleReload={handleReload}
                    idTrxOrigen={idTrxOrigen}/>
            </>
            ) : solicitud.codTipoInforme === TIPO_INFORME_MEDICO ? (
            <>
                <AtenderInformeMedico
                    showModal= {showModal} 
                    setShowModal={setShowModal} 
                    idCaso={idCaso}
                    idOrgCaso={idOrgCaso}
                    solicitud={solicitud}
                    handleReload={handleReload}
                    idTrxOrigen={idTrxOrigen}/>
            </>
            ) : null}
        </Fragment>
    </div>
  )
}
export default AtenderInformeProfesional